import { Platform } from 'react-native';
import Constants from 'expo-constants';

import { useAppSelector } from '@app/store/store';
import { selectUserProfile } from '@app/store/selectors';
import { useSiteConfig } from '@app/features/store-core';

export const useLiveChatPayload = () => {
  const userProfile = useAppSelector(selectUserProfile);
  const { siteConfig } = useSiteConfig();

  const fullName = [userProfile?.firstName, userProfile?.lastName].filter(Boolean).join(' ');
  const location = [siteConfig?.address?.city, siteConfig?.address?.state].filter(Boolean).join(', ');
  const appType = [Constants.expoConfig?.name, Platform.OS].filter(Boolean).join('-');

  const buildPayload = (pageModule: string, pageUrl?: string) => ({
    appType,
    appVersion: Constants.expoConfig?.version,
    deviceType: Platform.OS,
    name: userProfile?.firstName || userProfile?.userName,
    email: userProfile?.contactEmail,
    pageModule,
    pageUrl: pageUrl ?? (Platform.OS === 'web' ? window.location.href : ''),
    userLogin: userProfile?.userName,
    userRole: String(userProfile?.roles ?? ''),
    isLoggedIn: true,
    brandName: siteConfig?.companyInfo?.brand?.name,
    chainName: siteConfig?.companyInfo?.chainName,
    storeId: siteConfig?.stopId,
    storeName: siteConfig?.name,
    storeMarket: siteConfig?.configSettings?.marketTitle,
    storeLocation: location,
    storeCountry: siteConfig?.address?.country,
    storePlan: siteConfig?.config?.smsPlan?.toString(),
  });

  return {
    email: userProfile?.contactEmail,
    username: fullName || userProfile?.userName,
    buildPayload,
  };
};
